import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseClass } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { CommonService } from 'src/app/@shared/services/common.service';

@Component({
  selector: 'app-deposit-withdraw',
  templateUrl: './deposit-withdraw.component.html',
  styleUrls: ['./deposit-withdraw.component.css']
})
export class DepositWithdrawComponent extends BaseClass<any> implements OnInit {

  public iframeUrl: any;
  
  constructor(public service: WebserviceService,
    public router: Router,
    public _common: CommonService
  ) { super(); }

  ngOnInit(): void {
    this.getData()
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  getData() {
    this.isLoad = true;
    let url = this.router.url.includes('deposit') ? this.api.deposit : this.router.url.includes('withdraw') ? this.api.withdraw : '';
    this.getServices().Post(`${this.env.baseUrl + url}`, '').subscribe(
      (res) => {
        this.isLoad = false;
        this.iframeUrl = res?.data?.url.replace(':domain', `${this.env.domain}`)
        // console.log(this.iframeUrl);

      },
      (err) => {
        console.log(err);
      });
  }

  back() {
    this._common.back();
    // this.router.navigate(['/home']);
  }

}
